import { createContext, useContext } from 'react';

export type Theme = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export interface ThemeContextValue {
  /**
   * 현재 선택된 테마 설정
   */
  theme: Theme;

  /**
   * 실제 적용된 테마 (system인 경우 시스템 설정 반영)
   */
  resolvedTheme: ResolvedTheme;

  /**
   * 테마 변경 함수
   */
  setTheme: (theme: Theme) => void;

  /**
   * 다크 모드 여부
   */
  isDark: boolean;
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

/**
 * 테마 컨텍스트 훅
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { theme, setTheme, isDark } = useTheme();
 *
 *   return (
 *     <button onClick={() => setTheme(isDark ? 'light' : 'dark')}>
 *       {isDark ? '라이트 모드' : '다크 모드'}
 *     </button>
 *   );
 * }
 * ```
 */
export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
